<template>
    <d2-container>
        <h2>无效车牌告警</h2>
        <el-form ref="elForm" :model="formData" size="medium" label-width="120px">
            <el-row type="flex" justify="start" align="top">
                <el-col :span="6">
                    <el-form-item label="注册区县" prop="cityReq">
                        <town-com v-on:on-selectLast="(e) => listQuery.addressStreetId = e"></town-com>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="企业名称">
                        <el-input v-model="listQuery.entName" placeholder="请输入企业名称" clearable
                            :style="{ width: '445px' }"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>

                <el-col :span="6">
                    <el-form-item label="处理状态">
                        <el-select v-model="listQuery.isHandler" placeholder="请选择">
                            <el-option v-for="item in handlerOptions" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="告警日期" prop="dd">
                        <el-date-picker v-model="listQuery.notifyTime" type="daterange" align="right" unlink-panels
                            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                            value-format="yyyy-MM-dd" :picker-options="pickerOptions">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="撬装设备编码" prop="dd">
                        <el-input v-model="listQuery.oilEdequipmentCode" placeholder="撬装设备编码" clearable
                            :style="{ width: '763px' }"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item size="large">
                <el-button size="small" class="filter-item" type="primary" icon="search"
                    @click="handleFilter">查询</el-button>
                <el-button @click="resetForm">重置</el-button>
            </el-form-item>
        </el-form>

        <!--表格-->
        <el-button size="small" class="filter-item" style="margin-left: 10px;" @click="exportData('oil_alarm')"
            type="primary" icon="edit">导出全部数据</el-button>
        <el-table :key='tableKey' :data="list" v-loading.body="listLoading" size="small" stripe highlight-current-row
            style="width: 100%">
            <el-table-column prop="id" width="55" label="序号">
            </el-table-column>
            <el-table-column prop="content" label="告警内容" width="380">
            </el-table-column>
            <el-table-column prop="oilEdequipmentCode" label="撬装编码" width="140">
            </el-table-column>
            <el-table-column prop="entName" label="归属企业" width="220">
            </el-table-column>
            <el-table-column prop="addressStreetName" label="所在街镇" width="220">
            </el-table-column>
            <el-table-column prop="count" label="告警次数" width="80">
            </el-table-column>
            <el-table-column label="处理状态" width="180">
                <template slot-scope="scope">
                    <span v-if="scope.row.isHandler == 1">已处理</span>
                    <span v-else style="color:red;">未处理</span>
                </template>
            </el-table-column>
            <el-table-column label="告警时间" min-width="150" :fit="true">
                <template slot-scope="scope"><span style="white-space: nowrap;">{{ scope.row.createTime
                        }}</span></template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="220">
                <template slot-scope="scope">
                    <el-button size="small" type="" @click="handleClick(scope.row)">查看明细</el-button>
                    <el-button size="small" v-if="scope.row.isHandler != 1" type="success"
                        @click="handleUpdate(scope.row)">手动处理</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!--分页-->

        <template slot="footer">
            <div v-show="!listLoading" class="pagination-container">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page.sync="listQuery.page" :page-sizes="[10, 20, 30, 50]" :page-size="listQuery.limit"
                    layout="total, sizes, prev, pager, next, jumper" :total="total"> </el-pagination>
            </div>
        </template>

        <el-dialog :title="dialogStatus == 'update' ? '告警处理操作' : '告警详情'" :visible.sync="dialogFormVisible">
            <el-form :model="form" ref="form" label-width="140px">
                <div v-if="dialogStatus == 'update'">
                    <el-form-item label="处理结果">
                        <el-input v-model="form.result" placeholder="请输入处理结果内容"></el-input>
                    </el-form-item>
                </div>
                <div v-else>
                    <el-form-item label="告警内容" prop="content">
                        <el-input v-model="form.content" placeholder="告警内容"></el-input>
                    </el-form-item>
                    <el-form-item label="告警时间" prop="notifyTime">
                        <el-input v-model="form.notifyTime" placeholder="告警时间"></el-input>
                    </el-form-item>
                    <el-form-item label="处理状态" prop="isHandler">
                        <div v-text="form.isHandler == 1 ? '已处理' : '未处理'" style="margin-left:20px;"></div>
                    </el-form-item>
                    <el-form-item label="处理结果" v-if="form.isHandler == 1">
                        <el-input v-model="form.result" placeholder="处理结果内容"></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel('form')" size="small">取 消</el-button>
                <el-button v-if="dialogStatus == 'update'" size="small" type="primary"
                    @click="update('form')">确定</el-button>
            </div>
        </el-dialog>

        <el-drawer title="告警详情" :visible.sync="truckInComponentsVisible" :key="truckInComponentsVisible" direction="rtl"
            size="50%">
            <div>
                <el-descriptions title="" :column="1" border>
                    <el-descriptions-item label="告警内容">{{ form.content }}</el-descriptions-item>
                    <el-descriptions-item label="告警时间">{{ form.notifyTime }}</el-descriptions-item>
                    <el-descriptions-item label="处理状态">
                        <el-tag size="small">{{ form.isHandler == 1 ? '已处理' : '未处理' }}</el-tag>
                    </el-descriptions-item>
                    <el-descriptions-item label="处理结果">
                        {{ form.result }}
                    </el-descriptions-item>
                </el-descriptions>
                <div style="padding:10px 10px;">
                    <h2>抓拍记录</h2>
                    <TruckInComponents :carNo="form.ext1" :key="form.id"></TruckInComponents>
                </div>
            </div>
        </el-drawer>

    </d2-container>
</template>

<script>
import {
    page,
    addObj,
    getObj,
    delObj,
    putObj,
    exportNotifyCsv
} from '@/api/admin/sysNotifys/index';
import {
    mapGetters
} from 'vuex';
import TownCom from "../common/town-com.vue";
import TruckInComponents from "../common/TruckInComponents.vue"
export default {
    name: 'sysBaseMaterial',
    components: {
        TownCom,
        TruckInComponents
    },
    data() {
        return {
            dialogFormVisible: false,
            dialogFormDetailVisible: false,
            truckInComponentsVisible: false,
            formData: {
                platformName: undefined,
            },
            list: null,
            total: null,
            listLoading: true,
            handlerOptions: [{
                "label": "未处理",
                "value": 0
            }, {
                "label": "已处理",
                "value": 1
            }],
            listQuery: {
                page: 1,
                limit: 20,
                notifyType: "oil_alarm",
                notifyTime: [],
                isHandler: 0,
            },
            dialogFormVisible: false,
            dialogStatus: '',
            textMap: {
                view: '查看',
                update: '编辑',
                create: '创建'
            },
            tableKey: 0,
            form: {
                result: "",
                isHandler: 0,
                id: 0,
            },
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
        }
    },
    created() {
        this.getList();
    },
    computed: {
        ...mapGetters([
            'elements'
        ])
    },
    methods: {
        getList() {
            this.listLoading = true;
            let query = {
                ...this.listQuery
            };
            query.notifyTime = JSON.stringify(query.notifyTime);
            page(query).then(response => {
                this.list = response.rows;
                this.total = response.total;
                this.listLoading = false;
            })
        },
        handleFilter() {
            this.getList();
        },
        handleSizeChange(val) {
            this.listQuery.limit = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.listQuery.page = val;
            this.getList();
        },
        handleCreate() {
            this.resetTemp();
            this.dialogStatus = 'create';
            this.dialogFormVisible = true;
        },
        handleClick(row) {
            getObj(row.id)
                .then(response => {
                    this.form = response;
                    this.truckInComponentsVisible = true;
                });
        },
        handleUpdate(row) {
            getObj(row.id)
                .then(response => {
                    this.form = response;
                    this.dialogFormVisible = true;
                    this.dialogStatus = 'update';
                });
        },
        exportData(type) {
            let data = this.listQuery;
            exportNotifyCsv(type, "无效车牌告警.csv", data);
        },
        handleDelete(row) {
            this.$confirm('此操作将永久删除, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    delObj(row.devId)
                        .then(() => {
                            this.$notify({
                                title: '成功',
                                message: '删除成功',
                                type: 'success',
                                duration: 2000
                            });
                            const index = this.list.indexOf(row);
                            this.list.splice(index, 1);
                        });
                });
        },
        create(formName) {
            const set = this.$refs;
            set[formName].validate(valid => {
                if (valid) {
                    addObj(this.form)
                        .then((res) => {
                            if (res && res.code == 400) {
                                this.$notify({
                                    title: '提示',
                                    message: res.message,
                                    type: 'warning',
                                    duration: 2000
                                });
                                return;
                            }
                            this.dialogFormVisible = false;
                            this.getList();
                            this.$notify({
                                title: '成功',
                                message: '创建成功',
                                type: 'success',
                                duration: 2000
                            });
                        })
                } else {
                    return false;
                }
            });
        },
        cancel(formName) {
            this.dialogFormVisible = false;
            const set = this.$refs;
            set[formName].resetFields();
        },
        update(formName) {
            const set = this.$refs;
            set[formName].validate(valid => {
                if (valid) {
                    this.dialogFormVisible = false;
                    this.form.isHandler = 1;
                    putObj(this.form.id, this.form).then(() => {
                        this.dialogFormVisible = false;
                        this.getList();
                        this.$notify({
                            title: '成功',
                            message: '更新成功',
                            type: 'success',
                            duration: 2000
                        });
                    });
                } else {
                    return false;
                }
            });
        },
        resetTemp() {
            this.form = {
                devId: null,
                materialName: null,
                explainText: null,
                materialType: null,
                formType: null,
                sort: null,
            };
        },
        resetForm() {
            this.listQuery = {
                page: 1,
                limit: 20,
                notifyType: "oil_alarm",
                notifyTime: [],
                isHandler: 0,
            }
        }
    }
}
</script>

<style scoped>
.hideBlock {
    background-color: rgb(96 98 102);
    display: inline-block;
    width: 240px;
}

.hideBlock:hover {
    background-color: rgb(250 250 250);
}
</style>